<template>
    <article class="a-m-analysis">
        <div class="a-m-analysis__container">
            <div class="a-m-analysis__wrapper">
                <div class="a-m-analysis__date">
                    {{ dataRate.props.period.replace('Данные на', '') }}
                </div>
                <h3 class="a-m-analysis__title">
                    {{ dataRate.props.category.trim() }}
                </h3>
            </div>
            <p class="a-m-analysis__desc">
                {{ dataRate.name }}
            </p>
        </div>
        <div class="a-m-analysis__container">
            <div class="a-m-analysis__content">
                <table>
                    <thead>
                        <tr>
                            <th
                                v-for="(title, i) in  dataRate.props.table[0]"
                                :key="i">
                                {{ title }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(row, i) in  dataRate.props.table.slice(1, dataRate.props.table.length)"
                            :key="i">
                            <td
                                v-for="(col, j) in row"
                                :key="j">
                                {{ col }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="a-m-analysis__footer">
                <a  
                    v-if="dataRate.props.file"
                    class="a-m-analysis__link a-arrow-icon"
                    :href="dataRate.props.file.src"
                    :title="dataRate.props.file.name"
                    target="_blank">
                    Читать
                </a>
                <a
                    class="a-m-analysis__link a-arrow-icon"
                    :href="archiveLink.href + '?section=859'"
                    :title="archiveLink.title"
                    target="_blank">
                    {{ archiveLink.text }}
                </a>
            </div>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'Analysis',
        data() {
            return {
                archiveLink: {
                    href: '/analytics/archive/',
                    title: 'Архив отчетов',
                    text: 'Архив отчетов'
                },
                dataRate: null
            }
        },
        created() {
            let componentParent = document.querySelector('.js--a-analysis')
            if (!componentParent) {
                componentParent = document.querySelector('#app')
            }
            this.dataRate = JSON.parse(componentParent.getAttribute('mortgage-rate'))
        }
    }
</script>